export * from './rootStore';
export { default } from './rootStore';
import { enableStaticRendering } from 'mobx-react-lite';

enableStaticRendering(typeof window === 'undefined');
